export default function (fn) {
  const blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
  const url = URL.createObjectURL(blob);
  const worker = new Worker(url);
  URL.revokeObjectURL(url);
  return worker;
}
